"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useDropdownRegistry = void 0;
var _react = require("react");
const useDropdownRegistry = () => (0, _react.useMemo)(() => {
  const registry = new Set();
  const register = id => registry.add(id);
  const unregister = id => registry.delete(id);
  return {
    context: {
      registerNonClosableMenuItem: register,
      unregisterNonClosableMenuItem: unregister
    },
    isClosable: id => !registry.has(id)
  };
}, []);
exports.useDropdownRegistry = useDropdownRegistry;
//# sourceMappingURL=useDropdownRegistry.js.map